"use client";
import { Auth0Client } from '@auth0/auth0-spa-js';
import app from "firebase/compat/app";
import "firebase/compat/auth";
import { oktaRedirectUrl, auth0ClientConfig } from '../libs/fbConfig';
import { clearHandoffSession, isHandoffSession } from '../libs/handoffSession';
import { notification } from '../util/notification';
import formatMsg from '../util/formatMsg';
import { loginApi } from '../firebase-api/login';
function getauth0Instance(loginType: "sms" | null) {
    let authorizationParams: any = {
        redirect_uri: oktaRedirectUrl,
        audience: "illumine/auth",
    }
    const workspaceName = process.env.NEXT_PUBLIC_WORKSPACE_NAME;
    if (loginType === "sms") {
        authorizationParams.connection = "sms"
    }
    else if (workspaceName === "users") {
        authorizationParams.connection = "email"
    }
    const auth0 = new Auth0Client({ ...auth0ClientConfig, authorizationParams });

    return auth0
}

// Firebase restores a session asynchronously, so currentUser can still be null when the
// first API call of a page load goes out. Resolve on the first auth state instead.
function getMasterFirebaseUser() {
    return new Promise<any>((resolve) => {
        try {
            loginApi.initMasterConfig();
            const auth = app.auth();
            if (auth.currentUser) {
                resolve(auth.currentUser);
                return;
            }
            let unsubscribeListner: any;
            const settle = (user: any) => {
                if (unsubscribeListner) unsubscribeListner();
                resolve(user);
            };
            unsubscribeListner = auth.onAuthStateChanged(settle, () => settle(null));
        } catch (err) {
            console.log("Failed to read firebase auth state", err);
            resolve(null);
        }
    });
}

async function getHandoffIdToken() {
    try {
        const user = await getMasterFirebaseUser();
        if (!user) return undefined;
        // Firebase caches this and refreshes it on its own once it nears expiry.
        return await user.getIdToken();
    } catch (err) {
        console.log("Failed to get firebase id token", err);
        return undefined;
    }
}

async function getAuthToken() {
    // A session started by an Illumine handoff never went through Auth0: it holds a
    // Firebase session on Bookingo's own project, and the API takes that project's ID
    // tokens as an alternative to an Auth0 access token.
    if (isHandoffSession()) {
        const idToken = await getHandoffIdToken();
        if (idToken) {
            return idToken;
        }
        // The Firebase session is gone, so the handoff session is over. Fall through and
        // let the Auth0 path below end it the way any expired session is ended today.
        clearHandoffSession();
    }
    try {
        let authorizationParams: any = {
            redirect_uri: oktaRedirectUrl,
            audience: "illumine/auth",
        }
        const auth0 = new Auth0Client({ ...auth0ClientConfig, authorizationParams });
        let token = await auth0.getTokenSilently();
        return token;
    } catch (err) {
        loginApi.logout();
        console.log("Failure in login flow", err);
        notification("error", formatMsg("sessionExp"));

    }
}


export default { getauth0Instance, getAuthToken }